export default __webpack_public_path__ + "static/media/1a25c918dc74ab099b0bfbf67a950ef7.svg";